<template>
  <div>
    <div v-if="showPanel" class="fixed inset-0">
      <div class="absolute inset-0" @click="showPanel = !showPanel"></div>
    </div>
    <div class="relative inline-block text-left">
      <div v-if="!iconOnly">
        <span class="rounded-md">
          <button
            id="options-menu"
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
            aria-haspopup="true"
            aria-expanded="true"
            @click="showPanel = !showPanel"
          >
            <slot name="overrideTitle">
              {{ title }}
              <svg
                class="-mr-1 ml-2 h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </slot>
          </button>
        </span>
      </div>

      <div v-else>
        <span class="rounded-md">
          <button
            id="options-menu"
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-2 py-1 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
            aria-haspopup="true"
            aria-expanded="true"
            @click="showPanel = !showPanel"
          >
            <slot name="overrideTitle">
              {{ title }}
              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </slot>
          </button>
        </span>
      </div>

      <transition
        enter-active-class="transition ease-out duration-100"
        leave-active-class="transition ease-in duration-75"
        enter-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100"
        leave-class="transform opacity-100 scale-100"
        leave-to-class="transform opacity-0 scale-95"
      >
        <div v-if="showPanel" class="z-10 absolute mt-2 w-56 rounded-md" :class="alignmentClasses">
          <div
            class="rounded-md border border-gray-200 bg-white"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
            @click="showPanel = false"
          >
            <div v-if="sections > 0" class="py-1">
              <slot name="topmenu"></slot>
            </div>
            <div class="border-t border-gray-100"></div>
            <div v-if="sections > 1" class="py-1">
              <slot name="middlemenu"></slot>
            </div>
            <div class="border-t border-gray-100"></div>
            <div v-if="sections > 2" class="py-1">
              <slot name="bottommenu"></slot>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    iconOnly: Boolean,
    sections: Number,
    align: {
      type: String,
      default: 'right',
      validator: value => ['left', 'right', 'responsive'].includes(value),
    },
  },
  data() {
    return {
      showPanel: false,
    };
  },
  computed: {
    alignmentClasses() {
      if (this.align === 'left') {
        return 'left-0 origin-top-left';
      }
      if (this.align === 'responsive') {
        return 'left-0 origin-top-left xl:left-auto xl:right-0 xl:origin-top-right';
      }
      return 'right-0 origin-top-right';
    },
  },
};
</script>
